import { cn } from "@/lib/utils";
import type { Severity } from "@/api";

// Per the dashboard spec: INFO neutral, AGENT blue, ERROR orange, CRITICAL red.
// Light backgrounds with stronger text colours so badges read against the
// table's white surface and remain legible if the row is hovered.
const SEVERITY_CLASSES: Record<Severity, string> = {
  INFO: "bg-slate-100 text-slate-700 border-slate-200",
  AGENT: "bg-blue-100 text-blue-800 border-blue-200",
  ERROR: "bg-orange-100 text-orange-800 border-orange-200",
  CRITICAL: "bg-red-100 text-red-800 border-red-200",
};

export function SeverityBadge({
  severity,
  className,
}: {
  severity: Severity;
  className?: string;
}): JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold",
        SEVERITY_CLASSES[severity],
        className,
      )}
    >
      {severity}
    </span>
  );
}
